import { BE_BASE_URL } from 'constants/app'

export const downloadFileURL = (id: string | number) => {
  return `${BE_BASE_URL}/v1/export_journal_histories/${id || ''}/download`
}
